import React from 'react';
import './HowItWorks.css';

const steps = [
  {
    num: '01',
    icon: (
      <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>
    ),
    title: 'Browse & Choose',
    desc: 'Choose the plan by location, style, and budget. Find your perfect match in seconds.',
  },
  {
    num: '02',
    icon: (
      <svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
    ),
    title: 'Instant Booking',
    desc: 'Pick your slot, pay securely. No calls, no emails. Confirmed in under 10 minutes.',
  },
  {
    num: '03',
    icon: (
      <svg viewBox="0 0 24 24"><path d="M23 7l-7 5 7 5V7z" /><rect x="1" y="5" width="15" height="14" rx="2" /></svg>
    ),
    title: 'Shoot & Edit',
    desc: 'Your creator arrives, shoots like a pro, and edits on-the-go. Studio quality, delivered on location.',
  },
  {
    num: '04',
    icon: (
      <svg viewBox="0 0 24 24"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12" /></svg>
    ),
    title: 'Receive & Post',
    desc: 'Get your social-media-ready reel within minutes. Download, post, and watch the views roll in.',
  },
];

const delays = ['rd1', 'rd2', 'rd3', 'rd4'];

const HowItWorks = () => (
  <section className="hiw" id="how">
    <div className="container">
      <div className="hiw-head reveal">
        <span className="sec-label">Simple by design</span>
        <h2 className="sec-h2">From Booking to <em>Delivered</em><br />in Four Steps</h2>
      </div>
      <div className="hiw-grid">
        {steps.map((step, i) => (
          <div key={step.num} className={`hiw-card reveal ${delays[i]}`}>
            <div className="hiw-num">{step.num}</div>
            <div className="hiw-icon">{step.icon}</div>
            <div className="hiw-title">{step.title}</div>
            <div className="hiw-desc">{step.desc}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
